import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { DocumentTypeEntity } from '../models/distribution-object';
import { DistributionObjectGroup } from '../models/distribution-object-group';
import { JsonHttpService } from '../../shared/http/json-http.service'

@Injectable({
    providedIn: 'root'
})
export class DistributionObjectService {

    constructor(private httpService: JsonHttpService) { }

    getDistributionObjectGroups(includeOnlyUsableForDistributions: boolean = true): Promise<DistributionObjectGroup[]> {
        const options = { params: new HttpParams().set('includeOnlyUsableForDistributions', `${includeOnlyUsableForDistributions}`) };
        return this.httpService.get('/api/distribution/distributionobjects/get-distributionobject-groups', options).toPromise();
    }

    getDistributionObjects(): Promise<DocumentTypeEntity[]> {
        return this.httpService.get('/api/distribution/distributionobjects/get-distributionobjects').toPromise();
    }

    getDocumentTypesForDistributions(): Promise<DocumentTypeEntity[]> {
        const options = { params: new HttpParams().set('includeOnlyUsableForDistributions', true) };
        return this.httpService.get('/api/distribution/distributionobjects/get-distributionobjects', options).toPromise();
    }
}
